class ViewportPreserver {
  constructor(element) {
    this.element = element
    this.boundPreserveViewport = this.preserveViewport.bind(this)
    this.boundStopUnlessStream = this.stopUnlessStream.bind(this)
  }

  start(form) {
    this.focusedElement = document.activeElement
    this.scrollYBeforeSubmit = window.scrollY
    document.addEventListener("turbo:before-stream-render", this.boundPreserveViewport)
    form.addEventListener("turbo:submit-end", this.boundStopUnlessStream, { once: true })
  }

  stop() {
    document.removeEventListener("turbo:before-stream-render", this.boundPreserveViewport)
  }

  preserveViewport(event) {
    queueMicrotask(() => this.stop())
    const targetId = event.detail.newStream.target
    const target = document.getElementById(targetId)
    if (!target?.contains(this.element)) return

    const focusedFieldLocator = this.fieldLocator(target, this.focusedElement)
    const { scrollYBeforeSubmit } = this
    const render = event.detail.render

    event.detail.render = async (streamElement) => {
      await render(streamElement)
      this.fieldFromLocator(document.getElementById(targetId), focusedFieldLocator)?.focus({ preventScroll: true })
      window.scrollTo(window.scrollX, scrollYBeforeSubmit)
    }
  }

  stopUnlessStream(event) {
    if (!this.isTurboStreamResponse(event.detail.fetchResponse)) this.stop()
  }

  isTurboStreamResponse(fetchResponse) {
    return fetchResponse?.contentType?.startsWith("text/vnd.turbo-stream.html")
  }

  fieldLocator(container, field) {
    const key = this.nameAndValueKey(field)
    if (!key || !container.contains(field)) return null

    return { key, occurrence: this.fieldsMatchingNameAndValue(container, key).indexOf(field) }
  }

  fieldFromLocator(container, locator) {
    if (!container || !locator) return null

    return this.fieldsMatchingNameAndValue(container, locator.key)[locator.occurrence]
  }

  fieldsMatchingNameAndValue(container, key) {
    return Array.from(container.querySelectorAll("[name]:not([type=hidden])")).filter(field => this.nameAndValueKey(field) === key)
  }

  nameAndValueKey(field) {
    if (!field?.name) return null

    return `${field.name.replace(/\[\d+\]/g, "[]")}=${field.value}`
  }
}

export { ViewportPreserver }
